export const ITEMS_URL = 'bag/items';
export default ITEMS_URL;
